var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-container",attrs:{"src":'data:image/' + _vm.media.extension + ';base64, ' + _vm.media.data,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }